<template>
  <div class="panel granary-right-panel">
    <bar-card :bg="'border-new'">
      <g-title :bg="'hjzzjz'">帮镇扶村</g-title>
      <div class="content">
        <div class="top-content flex">
          <div
            :class="activeIndex === i ? 'top-item active-item' : 'top-item'"
            v-for="(item, i) in topList"
            :key="i"
            @click="handleClick(i)"
          >
            <div class="top-num">{{ item.num }}</div>
            <div class="name">
              {{ item.name }}
              <span v-show="item.unit">（{{ item.unit }}） </span>
            </div>
          </div>
        </div>
        <!-- <div class="area-title">扶贫项目数量变化趋势</div> -->
        <div class="fp-box">
          <div class="area-title">{{ activeName }}变化趋势</div>
          <div class="charts" ref="chart"></div>
        </div>
        <!-- <div class="area-title">各区扶贫项目数据占比</div> -->
        <div class="fp-box zb-box">
          <div class="area-title">各区{{ activeName }}占比</div>
          <div class="chart-box">
            <div class="tab-box flex">
              <div
                v-for="(item, index) in typeList"
                :key="index"
                class="tab-item"
                :class="{ active: active === index }"
                @click="changeType(index)"
              >
                <span>{{ item }}</span>
              </div>
            </div>
            <div class="charts" ref="circleChart"></div>
          </div>
        </div>
      </div>
    </bar-card>
  </div>
</template>

<script>
import gTitle from "../../components/gTitle";
import { loadChart } from "./charts/nccyData";
import { loadCircleChart } from "./charts/circleChart";
//import { getSCREEN_ZZCK } from "@/api/nzw";
import { timerMixin } from "@/util/mixin/timerMixin";
import { get } from "@/api/index";
// import { findIndexByName } from "@/util/index";
export default {
  mixins: [timerMixin],
  components: { gTitle },
  computed: {
    series() {
      if (this.activeIndex === 0) {
        return "户数";
      } else if (this.activeIndex === 1) {
        return "人数";
      } else if (this.activeIndex === 2) {
        return "帮扶资金";
      }
      return "帮扶项目";
    }
  },
  data() {
    return {
      typeList: [], //"2018", "2019"
      circleData: [],
      active: 0,
      topList: [
        // {
        //   name: "扶贫项目数",
        //   unit: "个",
        //   num: 25548
        // },
        // {
        //   name: "扶贫资金投入",
        //   unit: "万元",
        //   num: 1447.76
        // },
        // {
        //   name: "扶贫项目收益",
        //   unit: "万元",
        //   num: 77370.8
        // },
        // {
        //   name: "项目投入产出比",
        //   unit: "",
        //   num: "5.3 ：1"
        // }
      ],
      activeIndex: 0,
      activeName: "脱贫户数",
      unit: "个"
    };
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    this.circleChart = this.$echarts.init(this.$refs.circleChart);
    this.getLineData(true);
  },
  methods: {
    handleClick(i) {
      this.activeIndex = i;
      this.activeName = this.topList[i].name;
      this.unit = this.topList[i].unit;
      this.getLineData();
    },
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.getPieData();
      if (clearT) {
        this.startTimer();
      }
    },
    getLineData(first = false) {
      // new
      if (first) {
        get(
          "/api/dp/visual/getSeriesByDpPagePanelId?dpPagePanelId=77e1e199f7954aaf8f88346af48299af"
        ).then(res => {
          this.circleData = res.map(() => {
            return {
              datas0: [],
              datas: [],
              zjdatas: [],
              xmdatas: []
            };
          });
          const maxlen = res.length;
          let oknum = 0;
          this.typeList = res.map((e, i) => {
            get("/api/dp/visual/queryList", {
              code: "bfzj_rate",
              series: e.code
            }).then(res => {
              try {
                const { data } = res;
                let xmcode = "bfxm";
                let zjcode = "bfzj";
                // const fsindex = findIndexByName("户数", item, "name");
                // if (~fsindex) {
                //   fscode = item[fsindex]["code"];
                // }
                // const ysindex = findIndexByName("人数", item, "name");
                // if (~ysindex) {
                //   yscode = item[ysindex]["code"];
                // }
                this.circleData[i].xmdatas = data.map(d => {
                  return {
                    value: d[xmcode],
                    name: d["bfzj_rate_area"]
                  };
                });
                this.circleData[i].zjdatas = data.map(d => {
                  return {
                    value: d[zjcode],
                    name: d["bfzj_rate_area"]
                  };
                });
              } catch (error) {
                console.log("error", error);
              }
            });
            get("/api/dp/visual/queryList", {
              code: "tpgj_rate",
              series: e.code
            })
              .then(rs => {
                oknum++;
                try {
                  const { data } = rs;
                  let fscode = "tpgj_rate_hnum";
                  let yscode = "tpgj_rate_rnum";
                  // const fsindex = findIndexByName("户数", item, "name");
                  // if (~fsindex) {
                  //   fscode = item[fsindex]["code"];
                  // }
                  // const ysindex = findIndexByName("人数", item, "name");
                  // if (~ysindex) {
                  //   yscode = item[ysindex]["code"];
                  // }
                  this.circleData[i].datas0 = data.map(d => {
                    return {
                      value: d[fscode],
                      name: d["tpgj_rate_area"]
                    };
                  });
                  this.circleData[i].datas = data.map(d => {
                    return {
                      value: d[yscode],
                      name: d["tpgj_rate_area"]
                    };
                  });
                  if (oknum === maxlen) {
                    // 初始化ec
                    this.getPieData();
                    this.startTimer();
                  }
                } catch (error) {
                  console.log("error", error);
                }
              })
              .catch(() => {
                oknum++;
              });
            return e.code;
          });
        });
        get("/api/dp/visual/queryList?code=tpgj_index").then(res => {
          try {
            const { item, data } = res;
            if (Array.isArray(data) && data.length > 0) {
              const dt = data[0];
              this.topList = item
                .filter(e => e.name !== "扶贫资金")
                .map(e => {
                  let num = "";
                  if (dt[e.code]) {
                    num = dt[e.code];
                  }
                  return {
                    name: e.name,
                    unit: e.unit,
                    num
                  };
                });
            }
          } catch (error) {
            console.log("error", error);
          }
        });
      }
      // 中部变化趋势
      get("/api/dp/visual/queryList", {
        code: this.activeIndex < 2 ? "tpgj_change" : "bfzj_change",
        series: this.series
      }).then(res => {
        try {
          const { item, data } = res;
          if (Array.isArray(data) && data.length > 0) {
            const dt = data[0];
            let unit = "";
            const _arr = item.map((e, i) => {
              let value = null;
              if (i === 0) {
                unit = e.unit ? e.unit : this.activeIndex === 2 ? "万元" : "个";
              }
              if (dt[e.code]) {
                value = Number(dt[e.code]);
              }
              return {
                name: e.name,
                value
              };
            });
            loadChart(
              this.chart,
              _arr.map(e => e.name),
              _arr.map(e => e.value),
              unit
            );
          }
        } catch (error) {
          console.log("error", error);
        }
      });

      // old
      /*  get("/api/restful/cyzl/getPovertyAlleviationPlan").then(res => {
        // DEL LAST 2
        this.topList = res.data;
      });
      get("/api/restful/cyzl/getVintageIndicators", {
        type: this.activeName
      }).then(res => {
        let yearArr = [];
        let data = [];
        res.data.forEach(e => {
          yearArr.push(e.year);
          data.push(e.num);
        });
        loadChart(this.chart, yearArr, data, this.unit);
      });
      get("/api/restful/cyzl/getRegionalIndicators", {
        type: this.activeName
      }).then(res => {
        // TODO: check data is ok
        let types = []; // 存类型列表, eg：2018,2019
        let datas = [];
        res.data.forEach(ele => {
          if (types.indexOf(ele.year) === -1) {
            types.push(ele.year);
            datas.push({
              datas: [{ value: ele.num, name: ele.country }],
              typename: ele.year
              //   times: [ele.country] // x轴
            });
          } else {
            let index = findIndexByName(ele.year, datas, "typename");
            datas[index].datas.push({ value: ele.num, name: ele.country });
            // datas[index].times.push(ele.country);
          }
        });
        if (types.length > 0) {
          this.typeList = types;
          this.circleData = datas;
          this.getPieData();
          this.startTimer();
        }
      }); */
    },
    getPieData() {
      const fontSizes = 12;
      const widths = 10;
      const itemGaps = 10;
      let arrname = "datas0";
      if (this.activeIndex === 1) {
        arrname = "datas";
      } else if (this.activeIndex === 2) {
        arrname = "zjdatas";
      } else if (this.activeIndex === 3) {
        arrname = "xmdatas";
      }
      loadCircleChart(
        this.circleChart,
        this.circleData[this.active][arrname],
        fontSizes,
        widths,
        itemGaps,
        this.unit
      );

      window.addEventListener("resize", () => {
        this.circleChart.resize();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.panel
  // height calc(42% - 8px)
  // height calc(65% - 0px)
  height 100%
  font-size .06rem

.flex
  display flex
.content
  // height calc(100% - .2rem)
  padding 0 20px
  height 100%
  .top-content
      justify-content space-between
      flex-wrap wrap
      height 30%
      .top-item
        width 183px
        height 82px
        margin-top 30px
        padding-left 30px
        box-sizing border-box
        font-size 14px
        color #fff
        cursor pointer
        background url('~images/granary/nc/g-fpgh-bg.png') no-repeat
        background-size 100% 100%
        .top-num
          width 100%
          font-size 26px
          font-family 'electronicFont'
          margin-bottom 4px
          margin-top 16px
          color #00ffff
        .name
          width 100%
      .top-item:hover,.active-item
        background url('~images/granary/nc/y-fpgh-bg.png')
        background-size 100% 100%
        .top-num
          color #ff9b30
    .fp-box
      height 35%
      .area-title
        width fit-content
        text-align center
        color #89b4e5
        font-size 18px
        letter-spacing 1px
        line-height 26px
        border-bottom 1px solid #89b4e5
        margin 20px auto 0px
        box-sizing border-box
      .charts
        width 100%
        height calc(100% - 40px)
    .zb-box
      margin-top -10px
      .chart-box
        width 100%
        height 100%
        position relative
        .charts
          height calc(100% - 80px)
        .tab-box
          position absolute
          top 10px
          right 4%
          z-index 999
          .tab-item
            color #fff
            font-size 10px
            padding-left 13px
            margin-right 20px
            position relative
            cursor pointer
            &:before
              content ' '
              // width 6px
              // height 6px
              width 12px
              height 12px
              border-radius 50%
              background #fff
              position absolute
              left 0
              top 50%
              transform translateY(-50%)
          .active
            color #0e9cff
            &:before
              background #0e9cff
</style>
